import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import IntentType from "../../intentexecutor/utils/IntentType";
import { executeIntent } from "../utils/IntentExecutor";
import CustomModal from "../../components/generic/custommodal/CustomModal";
import { notification, Spin } from "antd";
import PrimaryButton from "../../components/generic/buttons/PrimaryButton";
import InvitationFormComponent from "./form/InvitationFormComponent";
import { strings } from "../utils/strings";

const InvitationComponent = () => {
  const [workforce, setWorkforce] = useState({});
  const [metadata, setMetadata] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [workforceError, setWorkforceError] = useState(null);
  const { search } = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(search);
  const invitationCode = params.get("invitationCode");

  useEffect(() => {
    const getWorkforceData = async () => {
      setWorkforceError(null);
      setIsLoading(true);

      if (!invitationCode) {
        setWorkforceError(strings.INVITATION_CODE_REQUIRED);
        setIsLoading(false);
        return;
      }

      const payload = {
        invitationCode: invitationCode,
      };

      try {
        const result = await executeIntent(
          IntentType.GET_WORKFORCE_BY_INVITATION_CODE,
          payload
        );
        const workforceData = result?.[0];

        if (!workforceData?.userIdentifier) {
          setWorkforceError(strings.INVALID_INVITATION);
          return;
        }

        setWorkforce(workforceData);
      } catch (error) {
        notification.error({
          message: "Something went wrong!",
          placement: "bottomRight",
        });
        setWorkforceError(strings.INVALID_INVITATION);
      } finally {
        setIsLoading(false);
      }
    };

    getWorkforceData();
  }, [invitationCode]);

  const formSubmitCallback = () => {
    setOpenModal(true);
  };

  const customButtons = (
    <div className="button-section">
      <div>
        <PrimaryButton
          buttonText="Login"
          handleOnClick={() => navigate("/login")}
          invitationForm={true}
        />
      </div>
    </div>
  );

  const closeButton = (
    <div className="button-section">
      <div>
        <PrimaryButton
          buttonText="Close"
          handleOnClick={() => navigate("/")}
          invitationForm={true}
        />
      </div>
    </div>
  );

  return (
    <>
      {isLoading ? (
        <Spin size="large" className="spinnerCenter" />
      ) : workforceError ? (
        <CustomModal
          isModalOpen={true}
          footer={[closeButton]}
          closeModal={() => navigate("/")}
          closable={false}
        >
          <div>
            <h5 className="font-weight-bold">{strings.REVOKED}</h5>
            <p>{workforceError}</p>
          </div>
        </CustomModal>
      ) : (
        <InvitationFormComponent
          workforce={workforce}
          setWorkforce={setWorkforce}
          metadata={metadata}
          setMetadata={setMetadata}
          formSubmitCallback={formSubmitCallback}
          customButtons={customButtons}
        />
      )}
      <CustomModal
        isModalOpen={openModal}
        footer={[customButtons]}
        closeModal={setOpenModal}
        closable={false}
      >
        <div>
          <h5>{strings.SIGNUP_SUCCESS}</h5>
          <p>{strings.SIGNUP_SUCCESS_MESSAGE}</p>
        </div>
      </CustomModal>
    </>
  );
};

export default InvitationComponent;
